import Api from "../apiService";

class requisiteTypesApi {
  index(companyId, params = {}) {
    const queryParts = [];

    Object.entries(params).forEach(([key, value]) => {
      if (value == null) return;

      if (Array.isArray(value)) {
        // Если значение — массив, добавляем каждый элемент с ключом [key]
        value.forEach((item) => {
          queryParts.push(`${key}[]=${encodeURIComponent(item)}`);
        });
      } else {
        // Если не массив — просто key=value
        queryParts.push(`${key}=${encodeURIComponent(value)}`);
      }
    });

    const queryString = queryParts.join("&");
    const url = `companies/${companyId}/requisite_types${
      queryString ? `?${queryString}` : ""
    }`;

    return Api.getRequest(url, {}, Api.authHeaders());
  }

  show(companyId, requisiteTypeId) {
    return Api.getRequest(
      `companies/${companyId}/requisite_types/${requisiteTypeId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, requisiteTypeData) {
    return Api.postRequest(
      `companies/${companyId}/requisite_types`,
      requisiteTypeData,
      Api.authHeaders()
    );
  }

  update(companyId, requisiteTypeId, requisiteTypeData) {
    return Api.patchRequest(
      `companies/${companyId}/requisite_types/${requisiteTypeId}`,
      requisiteTypeData,
      Api.authHeaders()
    );
  }

  toggle(companyId, requisiteTypeId) {
    return Api.postRequest(
      `companies/${companyId}/requisite_types/${requisiteTypeId}/toggle`,
      {},
      Api.authHeaders()
    );
  }
}

export default new requisiteTypesApi();
